import create from "zustand";

const useStore = create((set) => ({
  sidebar: window.innerWidth >= 992,
  update: payload => set(() => ({ ...payload })),
}));

export default useStore;
